<template>
  <div class="message-item">
    <!-- question -->
    <div
      class="receiver"
      v-if="
        message.questiontype &&
          message.questiontype != 'comment' &&
          message.questiontype != 'noreply'
      "
    >
      <div class="user">
        <template v-if="receiver.profile_pic">
          <v-avatar :size="15" color="grey lighten-4">
            <img class="profile" :src="receiver.profile_pic" alt />
          </v-avatar>
        </template>
      </div>
      <div class="message" style="position: relative;">
        <message-viewer
          v-model="parseQuestionMessage"
          :size="'small'"
          :showProfile="false"
          :align="value.answerby != '' || value.answerby == 'bot' ? 'right' : 'left'"
        ></message-viewer>
        <small class="messageTime">{{ value.timestamp | dateFormat }}</small>
      </div>

      <div class="clearfix"></div>
    </div>

    <!-- answer -->
    <div
      class="sender"
      :class="{ bot: value.answerby == 'bot' }"
      v-if="
        (value.answerby != '' || value.answerby == 'bot') &&
          parseAnswerMessage[0].length > 0 &&
          message.messagetype != 'noreply'
      "
    >
      <div class="user">
        <v-avatar :size="15" color="grey lighten-4">
          <img
            class="profile"
            :src="'https://graph.facebook.com/' + selectedBot.pageid + '/picture'"
            alt
          />
        </v-avatar>
      </div>
      <div class="message" style="position: relative;">
        <message-viewer
          v-model="parseAnswerMessage"
          :size="'small'"
          :showProfile="false"
          :align="value.answerby != '' || value.answerby == 'bot' ? 'right' : 'left'"
        ></message-viewer>
        <small class="messageTime" style="right: 0">{{ value.timestamp | dateFormat }}</small>
      </div>

      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageViewer from '@/components/elements/MessageViewer'
import moment from 'moment'

export default {
  props: ['value', 'receiver'],
  data: function() {
    return {
      message: this.value,
      isError: false
    }
  },
  components: {
    MessageViewer
  },
  filters: {
    dateFormat(v) {
      return moment(v).format('DD-MM-YYYY HH:mm')
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isReceiver: function() {
      // sender == admin and bot
      // receiver == customer
      return this.value.answerby == ''
    },
    parseAnswerMessage: function() {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.messagedata
      var chattype = vm.message.messagetype

      if (chattype == 'template') {
        if (vm.message.intent == '{welcome}') {
          messages = [
            [
              {
                type: 'welcome_message'
              }
            ]
          ]
        } else {
          try {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail)
                }
              ]
            ]
          } catch (error) {
            messages = [
              [
                {
                  type: 'text',
                  text: chatdetail
                }
              ]
            ]
          }
        }
      } else if (chattype == 'text' && chatdetail.includes('{welcome_message}')) {
        messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (chattype == 'json' || chattype == 'replyinbox') {
        try {
          var message = JSON.parse(chatdetail)
          messages[0] = message
        } catch (error) {
          vm.isError = true
        }
      } else if (chattype == 'noreply' || chatdetail == '') {
        vm.$set(vm.message, 'messagetype', 'noreply')
      } else {
        var newGroup = []
        var group = chatdetail.split('||')
        $.each(group, function(index, messages) {
          var newMessage = []
          var group_messages = messages.split('#nl')
          $.each(group_messages, function(index, message) {
            var type = 'text'
            if (!isNaN(message)) {
              newMessage.push({
                type: 'text',
                text: message
              })
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              newMessage.push({
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button'
              })
            } else if (vm.isURL(message)) {
              newMessage.push({
                type: 'image',
                image_url: message
              })
            } else {
              newMessage.push({
                type: 'text',
                text: message
              })
            }
          })
          newGroup.push(newMessage)
        })
        messages = newGroup
      }

      return messages
    },
    parseQuestionMessage: function() {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.questiondata
      var chattype = vm.message.questiontype

      if (chattype) {
        if (chattype == 'template') {
          if (vm.message.intent == '{welcome}') {
            messages = [
              [
                {
                  type: 'welcome_message'
                }
              ]
            ]
          } else {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail)
                }
              ]
            ]
          }
        } else if (chattype == 'json') {
          try {
            messages = JSON.parse(chatdetail)
          } catch (error) {
            vm.isError = true
          }
        } else if (chattype == 'noreply' || chatdetail == '') {
          vm.$set(vm.message, 'questiontype', 'noreply')
        } else if (chattype == 'image') {
          messages = [
            [
              {
                type: 'image',
                image_url: chatdetail
              }
            ]
          ]
        } else {
          var newGroup = []
          var group = chatdetail.split('||')
          $.each(group, function(index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function(index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
              // else if (vm.isURL(message)) {
              //   newMessage.push({
              //     type: 'image',
              //     image_url: message
              //   })
              // }
            })
            newGroup.push(newMessage)
          })
          messages = newGroup
        }
      }

      return messages
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.message = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  margin: 5px;
}
.receiver {
  white-space: nowrap;
  .user,
  .message {
    float: left;
  }

  .user {
    margin-right: 5px;
  }
}
.sender {
  white-space: nowrap;
  .user,
  .message {
    float: right;
  }

  .user {
    margin-left: 5px;
  }
}
.messageTime {
  position: absolute;
  bottom: -7px;
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-message.vue